import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const DrillIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-drill"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="8 24 60 24 60 19 8 19"
        />
        <path
          d="M52.567,17 C54.1995007,17 55.112799,17.2619173 56.4782828,17.9714757 L56.7577558,18.119411 C57.9286226,18.7495021 58.5517834,18.9687074 59.7201911,18.9968077 L60,19 L60,21 C58.3680629,21 57.4550395,20.7381413 56.0897948,20.0287015 L55.8103692,19.8807908 C54.5491868,19.2020972 53.9232076,19 52.567,19 C51.3081068,19 50.6787359,19.1742034 49.5858582,19.7423568 L49.3249302,19.8805624 C47.7986346,20.7020347 46.8759355,21 45.135,21 C43.5035638,21 42.5909485,20.7380774 41.2261975,20.0284136 L40.9468719,19.8804559 C39.6869612,19.2019902 39.0618014,19 37.707,19 C36.4491043,19 35.8201363,19.1741604 34.7280633,19.742122 L34.4673286,19.8802806 C32.9412798,20.7019518 32.0185971,21 30.278,21 C28.6465638,21 27.7339485,20.7380774 26.3691975,20.0284136 L26.0898719,19.8804559 C24.8299612,19.2019902 24.2048014,19 22.85,19 C21.5929677,19 20.9644704,19.174122 19.8730958,19.7420283 L19.3329357,20.028334 C17.9687,20.7380044 17.0561189,21 15.425,21 C13.7944447,21 12.8821385,20.7380631 11.5181419,20.0285115 L10.9779756,19.7422026 C9.97033724,19.2178746 9.3570798,19.0291274 8.27955134,19.0031919 L8,19 L8,17 C9.63111893,17 10.5437,17.2619956 11.9079357,17.971666 L12.4480958,18.2579717 C13.5394704,18.825878 14.1679677,19 15.425,19 C16.682609,19 17.3113674,18.8258194 18.4029756,18.2577974 L18.9431419,17.9714885 C20.3071385,17.2619369 21.2194447,17 22.85,17 C24.4814362,17 25.3940515,17.2619226 26.7588025,17.9715864 L27.0381281,18.1195441 C28.2980388,18.7980098 28.9231986,19 30.278,19 C31.5364723,19 32.1657015,18.8257811 33.2580081,18.2577038 L33.5187964,18.1195175 C35.0445941,17.2979815 35.9670041,17 37.707,17 C39.3384362,17 40.2510515,17.2619226 41.6158025,17.9715864 L41.8951281,18.1195441 C43.1550388,18.7980098 43.7801986,19 45.135,19 C46.3938932,19 47.0232641,18.8257966 48.1161418,18.2576432 L48.3770698,18.1194376 C49.9033654,17.2979653 50.8260645,17 52.567,17 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
        <path
          d="M61,8 L7,8 L7,26 L61,26 L61,8 Z M59,10 L59,24 L9,24 L9,10 L59,10 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#ffffff"
          className={styles.white}
          points="49.559 26.813 46.787 25.665 54.441 7.187 57.213 8.335"
        />
        <path
          d="M57.8662967,8.06417493 L54.1703936,6.53354839 L46.1337033,25.9354251 L49.8296064,27.4660516 L57.8662967,8.06417493 Z M54.711,7.839 L56.56,8.605 L49.288,26.159 L47.44,25.393 L54.711,7.839 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#ffffff"
          className={styles.white}
          points="40.559 26.813 37.787 25.665 45.441 7.187 48.213 8.335"
        />
        <path
          d="M48.8662967,8.06417493 L45.1703936,6.53354839 L37.1337033,25.9354251 L40.8296064,27.4660516 L48.8662967,8.06417493 Z M45.711,7.839 L47.56,8.605 L40.288,26.159 L38.44,25.393 L45.711,7.839 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#ffffff"
          className={styles.white}
          points="31.559 26.813 28.787 25.665 36.441 7.187 39.213 8.335"
        />
        <path
          d="M39.8662967,8.06417493 L36.1703936,6.53354839 L28.1337033,25.9354251 L31.8296064,27.4660516 L39.8662967,8.06417493 Z M36.711,7.839 L38.56,8.605 L31.288,26.159 L29.44,25.393 L36.711,7.839 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#ffffff"
          className={styles.white}
          points="22.559 26.813 19.787 25.665 27.441 7.187 30.213 8.335"
        />
        <path
          d="M30.8662967,8.06417493 L27.1703936,6.53354839 L19.1337033,25.9354251 L22.8296064,27.4660516 L30.8662967,8.06417493 Z M27.711,7.839 L29.56,8.605 L22.288,26.159 L20.44,25.393 L27.711,7.839 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#ffffff"
          className={styles.white}
          points="13.559 26.813 10.787 25.665 18.441 7.187 21.213 8.335"
        />
        <path
          d="M21.8662967,8.06417493 L18.1703936,6.53354839 L10.1337033,25.9354251 L13.8296064,27.4660516 L21.8662967,8.06417493 Z M18.711,7.839 L20.56,8.605 L13.288,26.159 L11.44,25.393 L18.711,7.839 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
